import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "meetingSession",
    "classroomCreditMessage"
  ]

  static values = { classroomCredits: Object }

  connect() {
    this.updateClassroomCreditMessage()
  }

  change() {
    this.updateClassroomCreditMessage()
  }

  updateClassroomCreditMessage() {
    const selectedValue = this.meetingSessionTarget.value;
    const classroomCredits = this.classroomCreditsValue || {};
    const hasClassroomCredit = classroomCredits[selectedValue] === true;

    if (this.hasClassroomCreditMessageTarget) {
      if (hasClassroomCredit) {
        this.classroomCreditMessageTarget.classList.remove('u-hidden');
      } else {
        this.classroomCreditMessageTarget.classList.add('u-hidden');
      }
    }
  }
}
